import React, { ReactElement } from "react";
import Layout from "Layout";
import ResetPasswordForm from "./ResetPasswordForm";
import styles from "./styles.module.scss";

function ResetPassword(): ReactElement {
  return (
    <Layout>
      <div className={styles.resetPasswordPageInfo}>
        <h1>Change Password</h1>
        <div className={styles.barContainer}>
          <div className={styles.bar} />
        </div>
        <div className={styles.resetPasswordForm}>
          <ResetPasswordForm />
        </div>
      </div>
    </Layout>
  );
}

export default ResetPassword;
